<template>
  <div>
    <div class="lds-facebook"  v-if="loading"><div></div><div></div><div></div></div>
      <a-card title="All Zoom Contracts" :bordered="false">
        <a-button type="primary" size="small" slot="extra" @click="visible = true">Add new account</a-button>
        <table class="table table-sm" v-if="getall">
          <thead>
            <tr>
              <th scope="col">Email</th>
              <th scope="col">Application</th>
              <th scope="col">Default</th>
              <th scope="col">Personal</th>
              <th scope="col">Cross</th>
              <th scope="col">View/Edit</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in contracts" :key="i">
              <th scope="row">{{item.account_email}}</th>
              <th scope="row">{{item.ew_app_name}}</th>
              <th scope="row">{{item.default === 1 ? 'YES' : 'NO'}}</th>
              <th scope="row">{{item.is_personal === 'YES' ? 'Personal Account' : 'App Account'}}</th>
              <th scope="row">
                {{item.cross_account == 0 ? 'NO' : 'YES'}}
              </th>
              <th scope="row">
                <a-button type="warning" title="Update!" size="small" @click="editAccountDetails(item.id)">
                    <span class="ti-pencil" ></span>
                </a-button> | 
                <router-link :to="{ path: '/contracts/'+item.id+'/rooms'}" class="btn-info btn-sm" exact>Manage Contracts</router-link></th>
            </tr>
          </tbody>
        </table>

      </a-card>
       <a-modal
            :footer="null"
            title="Add new account!"
            :visible="visible"
            @cancel="cancel"
            >
            <a-row>
              <a-form :form="form" @submit="addNewAccount">
                <a-form-item label="Application">
                    <a-select
                        v-decorator="[
                        'application',
                        { initialValue:'cross',rules: [{ required: true, message: 'Please select aplication!' }] },
                        ]"
                    >
                        <a-select-option value="cross" key="cross" selected>
                           Cross Account
                        </a-select-option>
                        <a-select-option v-for="(item,i) in applications" :key="i" :value="item.ew_app_id">
                           {{item.ew_app_name}}
                        </a-select-option>
                        
                    </a-select>
                </a-form-item>
                <a-form-item label="Email">
                    <a-input type="email"
                        v-decorator="['email', { rules: [{ required: true, message: 'Please insert email!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="Zoom Key">
                    <a-input
                        v-decorator="['zoom_key', { rules: [{ required: true, message: 'Please insert zoom key!' }] }]"
                    />
                </a-form-item>
                <a-form-item label="Zoom secret">
                    <a-input
                        v-decorator="['zoom_secret', { rules: [{ required: true, message: 'Please insert zoom secret!' }] }]"
                    />
                </a-form-item>
                <a-button type="primary" html-type="submit">
                    Submit
                </a-button>
              </a-form>
          </a-row>
      </a-modal>
               <a-modal
            :footer="null"
            title="Edit Room!"
            :visible="editmodal"
            @cancel="cancel"
            >
            <a-row>
              <a-form :form="formedit" @submit="uodateAccountDetalsOnSubmit">
                <a-form-item label="Application">
                    <a-select
                        v-decorator="[
                        'crossapp',
                        { initialValue: String(account.cross_account),rules: [{ required: true, message: 'Please select!' }] },
                        ]"
                    >
                        <a-select-option value="0" key="cross" selected>
                          No
                        </a-select-option>
                        <a-select-option value="1">
                          Yes
                        </a-select-option>
                        
                    </a-select>
                </a-form-item>
                <a-button type="primary" html-type="submit">
                    Submit
                </a-button>
              </a-form>
          </a-row>
        </a-modal>
  </div>
</template>
<script>
const columns_users = [
  {
    title: 'Name',
    key:'name',
    dataIndex: 'name',
    width: 150,
  },
  {
    title: 'Email',
    key:'email',
    dataIndex: 'email',
    width: 150,
  }
];
const columns_institutions = [
  {
    title: 'Institution Id',
    key:'ew_ins_id',
    dataIndex: 'ew_ins_id',
    width: 150,
  },
  {
    title: 'Institution Name',
    key:"ew_ins_name",
    dataIndex: 'ew_ins_name',
    width: 150,
  }
];

import API from '../../services/api';

export default {
  data() {
    return {
        loading:true,
        applications:[],
        columns_users,
        columns_institutions,
        visible:false,
        form: this.$form.createForm(this),
        getall:false,
        contracts:[],
        applications:[],
        account:{},
        editmodal:false,
        formedit: this.$form.createForm(this)
    };
  },
  computed: {
    userLogin() {
      return this.$store.state.auth.user;
    }
  },
  created(){
      this.getContracts();
      this.getApplications()
  },
  methods: {
    async addNewApplication(){
       this.visible = true
    },
    uodateAccountDetalsOnSubmit(e){
      e.preventDefault();
      this.formedit.validateFields((err, values) => {
        if (!err) {
          API.put(`/api/admin/account/cross/${this.account.id}`,values).then(res => {
               if(res.status === 200){
                    this.$message.success('Updated successfully!')
                    this.getContracts()
                    this.editmodal = false
                }
          })
        }
      })
    },
    editAccountDetails(account){
      this.editmodal = true
      this.account = this.contracts.filter(item => item.id === account)[0]
    },
    getApplications(){
        API.get(`/api/admin/apps`)
        .then(response => { 
          console.log(response)
          this.applications = response.data
        })
        .catch(error => console.log(error));
    },

    handleCancelAction(e) {
        this.visible = false;
    },

    deleteApp(id){
      API.delete(`/admin/${this.userLogin.email}/applications/${id}`)
      .then(response => {
          this.$message.success('Deleted successfully!')
          this.getContracts()
      })
    },
    async resetForm(){
     this.form.resetFields()
    },
    async getContracts(){
        API.get(`/api/admin/contracts`)
        .then(response => { 
           this.contracts = response.data
           this.getall = true,
           this.loading = false
        })
        .catch(error => console.log(error));
        
    },
    handleClick(event,id){
        event.stopPropagation();
        this.$router.push(`/application/${id}`)
    },
     addNewAccount(e){
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          API.post(`/api/admin/contracts`,values).then(res => {
            if(res.status && res.status === 201){
              this.$message.success('Inserted successfully!')
              this.getContracts()
              this.visible = false
              this.resetForm()
            }else{
              this.$message.warning('This account exist!')
              this.getAccounts()
            }
          })
        }
      })
    },
    
    cancel(){
      this.visible = false
      this.editmodal = false
    },

  }
};
</script>
<style>
</style>
